export default __webpack_public_path__ + "static/media/ssf_color.b025599e.png";